import React from 'react';
import Header from './components/Header';
import Social from './components/Social';
import About from './components/About';
import Accordions from './components/Accordions';
import TypeWriter from './components/TypeWriter';
import ImageSwiper from './components/ImageSwiper';
import Clients from './components/Clients';
import Share from './components/Share';
import Footer from './components/Footer';
import background from './images/bg.jpg';
import BottomSwiper from './components/BottomSwiper';

function App() {

  var domainUrl = 'https://devorahslane.netlify.app/'
  var businessName = "Devorah's Lane"
  var businessDescription = 'Hair removal & Skin care clinic'
  var phoneNumber = '+972584060644'
  var email = 'devslane28@gmail.com'
  var facebookUrl = 'https://www.facebook.com/devorahyaffebarr?mibextid=LQQJ4d'
  var instagram = 'devorahslane'
  var whatsapp = '+972584060644'
  var wazeUrl = 'https://www.waze.com/he/live-map/directions/il/%D7%9E%D7%97%D7%95%D7%96-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%91%D7%99%D7%AA-%D7%A9%D7%9E%D7%A9/%D7%90%D7%A9%D7%A8-23?to=place.EiBBc2hlciBTdCAyMywgQmV0IFNoZW1lc2gsIElzcmFlbCIwEi4KFAoSCc3B5m1jxAIVEfke5wUQcbi0EBcqFAoSCWkG2nNjxAIVETQg3pAJU9Ka'
  var days = "Sunday - Thursday"
  var hours = '8:30 -17:30'
  //קצת עליי
  //טיפולים בקליניקה
  //לקוחות ממליצים
  //icon
  //שם ותיאור


  const divStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };
  return (
    <div className="bg-gray-50 w-full">
      <div className=" md:w-4/5 lg:max-w-[1152px] mx-auto shadow-2xl">
        <div className="object-cover">
          <div style={divStyle}>
            <Header
              businessName={businessName}
              businessDescription={businessDescription} />

            <Social
              businessName={businessName}
              businessDescription={businessDescription}
              phoneNumber={phoneNumber}
              email={email}
              facebookUrl={facebookUrl}
              instagram={instagram}
              whatsapp={whatsapp}
              wazeUrl={wazeUrl}
              domainUrl={domainUrl}
            />
            <About />

            <Accordions
              phoneNumber={phoneNumber}
              email={email}
              days={days}
              hours={hours}
            />
            <TypeWriter
              businessName={businessName}
              businessDescription={businessDescription}
            />

          </div>
          <div style={divStyle}>
            <ImageSwiper />

            <BottomSwiper />

            <Clients
              whatsapp={whatsapp} />

            <Share domainUrl={domainUrl} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
